import { apiFetch } from "@/lib/api-client";
const PRODUCTION_LANDING_URL = "https://bodybloom.ai";
export function getLandingBaseUrl() {
    var _a;
    const configured = (_a = process.env.REACT_APP_LANDING_URL) === null || _a === void 0 ? void 0 : _a.trim();
    if (configured)
        return configured.replace(/\/+$/, "");
    if (process.env.NODE_ENV === "production")
        return PRODUCTION_LANDING_URL;
    return "http://localhost:8080";
}
/** Hard redirect to Karen's marketing site (no SSO ticket). */
export function redirectToLanding(continuation) {
    const url = new URL(`${getLandingBaseUrl()}/`);
    if (continuation) {
        url.searchParams.set("continuation", continuation);
        url.hash = "#/login";
    }
    window.location.replace(url.toString());
}
/**
 * After logging out of the app, send the user to Karen with a logout signal
 * so the marketing site clears its local session too.
 */
export function redirectToLandingLoggedOut() {
    const url = new URL(`${getLandingBaseUrl()}/`);
    url.searchParams.set("logout", "1");
    window.location.replace(url.toString());
}
/** True when returnTo is the configured marketing-site origin (no open redirects). */
export function isAllowedLandingReturnUrl(returnTo) {
    try {
        const target = new URL(returnTo);
        const allowed = new URL(getLandingBaseUrl());
        return target.origin === allowed.origin;
    }
    catch (_a) {
        return false;
    }
}
export async function redirectToLandingWithSession(accessToken) {
    const response = await apiFetch("/api/auth/login-ticket", {
        method: "POST",
        token: accessToken,
    });
    if (!response.ok) {
        throw new Error("Failed to create login ticket for the marketing site");
    }
    const data = (await response.json());
    if (!data.ticket) {
        throw new Error("Login ticket response did not include a ticket");
    }
    const url = new URL(`${getLandingBaseUrl()}/`);
    url.searchParams.set("ticket", data.ticket);
    window.location.href = url.toString();
}
